import type { SliderItem } from 'hb-builder/components/BuilderComponents/page/block/Gallery/components/InfiniteSlider/types';
import BuilderThemeProvider, {
  VIEW_AS,
} from 'hb-builder/components/common/BuilderThemeProvider';
import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import {
  useBuilderConfigContext,
  useBuilderContext,
  useComponentContext,
  useRendererContext,
} from 'hb-builder/hooks';
import type { BuilderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { SliderItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/galleryItemAttributes';

import InfiniteSliderUI from './components';

const InfiniteSlider: BuilderComponent = () => <div />; // never used

const RenderBuilder = () => {
  const { updateAttribute } = useBuilderContext();
  const { item } = useComponentContext();
  const {
    hivebrite: { subdomainNetworkUrl },
  } = useBuilderConfigContext();

  const handleToggleDrawer = (image: DocumentItem<SliderItemAttributes>) => {
    const isOpen = item.attributes?.__isSelected === image.id;

    updateAttribute({
      id: item.id,
      attribute: '__isSelected',
      value: isOpen ? null : image.id,
    });
  };

  return item ? (
    <BuilderThemeProvider viewAs={VIEW_AS.USER}>
      <InfiniteSliderUI
        item={item as SliderItem}
        subdomainNetworkUrl={subdomainNetworkUrl}
        toggleDrawer={handleToggleDrawer}
      />
    </BuilderThemeProvider>
  ) : null;
};

const Render = ({ item }: RenderProps<SliderItem>) => {
  const { subdomainNetworkUrl } = useRendererContext();

  if (!item) return null;

  return (
    <InfiniteSliderUI item={item} subdomainNetworkUrl={subdomainNetworkUrl} />
  );
};

InfiniteSlider.componentName = 'InfiniteSlider';
InfiniteSlider.componentType = 'single';

InfiniteSlider.canBeDoubleClicked = true;
InfiniteSlider.canBeDragged = true;
InfiniteSlider.canBeListed = true;
InfiniteSlider.canBeSelected = true;

InfiniteSlider.RenderBuilder = RenderBuilder;
InfiniteSlider.Render = Render;

InfiniteSlider.item = ({ attributes, children = [] }) => ({
  attributes,
  children,
  type: InfiniteSlider.componentName,
});

export default InfiniteSlider;
